const EmailConversationViewConstants = {
    ITEM_SPACING: 8,
};

export default EmailConversationViewConstants;